import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import swal from "sweetalert";
import {array, object, string, boolean, required, mixed} from "yup";
import ParticipationFormFields from './ParticipationFormFields'

class ParticipationForm extends React.Component {

    render() {

        return <ParticipationFormFields {...this.props}/>

    }

}

const FormConfig = withFormik({
    mapPropsToValues: props => {
        return mergeWithDefault(props.values, {
            id_course: props.course.id,
            id_person: '',
            day_course_entry: '',
            day_course_withdrawel: '',
            student: null,
        });
    },

    // validationSchema: () => {
    //     let rules = object().shape({
    //         first_name: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.first_name')})
    //         ),
    //         last_name: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.last_name')})
    //         ),
    //     });

        // todo: company nur validieren wenn checkbox angehakt
        // company_name: string().required(
        //     i18n.get('validation.required', {attribute: i18n.get('contacts.first_name')})
        // )

        // return rules
    // },

    handleSubmit: (values, {props}) => {
        axios.post(props.formUrl, values).then(() => {
            swal({
                icon: "success",
                title: i18n.get('participations.save_success'),
                text: i18n.get('participations.you_will_be_redirected'),
                timer: 4000,
            }).then(() => {
                window.location.href = props.redirectAfterSubmit
            })
        }).catch(() => {
            swal({
                icon: "error",
                title: i18n.get('participations.ajax_error'),
            })
        })
    },

    validateOnBlur: true

})(ParticipationForm)

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    }
});

export default withStyles(styles)(FormConfig)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Participations/ParticipationForm.js